<section class="no-auth-page">
  <header>
    <h3>{{ 'auth.signup.title' | translate }}</h3>
    <h4>{{ 'auth.signup.subtitle' | translate }}</h4>
  </header>

  <signup-form></signup-form>

  <p class="hint-text">
    {{ 'auth.signup.hintText' | translate }}
    <button ht-button-primary appearance="minimal" routerLink="/sign-in">{{
      'auth.signup.signIn' | translate
    }}</button>
  </p>
</section>
